import OptionPresenter from "@adapters/features/Markets/Options/Presenter/Options";
import OptionsChainGraph from "@adapters/features/Markets/Options/Presenter/OptionGraph";
import OptionDrivingMarketManager from "@adapters/features/Markets/Options/Presenter/OptionDrivingMarketManager";
export default (function (useCases, actions) {
    return {
        options: new OptionPresenter(useCases.optionMarket, actions.option, new OptionsChainGraph(actions.option, useCases.optionMarket), new OptionDrivingMarketManager(useCases.optionsDriveMarket, actions.optionDrivingMarkets, useCases.optionMarket.qouteStreaming), useCases.optionMarket.qouteStreaming),
    };
});
